<template>
  <div class="master-item">
    <div class="master-card">
      <img class="img" :src="head_img" />
      <div class="master-info flex-direction flex justify-center">
        <div class="name flex align-center">
          <div>
            {{ nickname }}
          </div>
          <div class="moneySave">
            <img class="baoMoney" :src="baoIcon||'../../../../assets/images/logo.png'" />
          </div>
        </div>
        <div class="desc padding-top-4">
          <!-- <span class="mrs">近三个月被投诉{{ thressMonthsCount }}次</span> -->
          <!-- <span class="pions">查看评价</span> -->
        </div>
        <div class="desc padding-tb-4">
          <span class="mrs"> 近1个月完成{{ lastMonthNumber||0 }}单 </span>
          <!-- <span class="pions">查看员工图</span> -->
          <span class="pions">总共完成{{worker_order||0}}单</span>

        </div>
        <!-- <div class="desc margin-top-xs">总共完成{{worker_order||0}}单</div> -->
        <div class="num">合作{{cooperateNumber||0}}次</div>
        <div class="textarea margin-top-xs" v-if="message != ''">
          <div class="">师傅留言：{{ message }}</div>        
        </div>
      </div>
      <div class="contact">
        <div class="text1">报价：{{ offer }}</div>
        <div class="text margin-top" v-if="tolls_time">上门时间：{{ tolls_time }}</div>
      </div>
      <div class="contact">
        <div class="text">综合评分：{{ score }}分</div>
      </div>
      <div class="handle margin-right">
        <Button type="primary" size="small" class="btn" v-if="detail_status>3" @click="$router.push({ name: 'order_complaint', params: { id: order_id } })">投诉师傅</Button>
        <Button type="primary" size="small" class="btn" @click="assign()" v-if="detail_status == 2">指派TA</Button>
        <Button type="primary" size="small" class="btn" v-if="worker_id != detail_worker_id && detail_status == 3" :disabled="true">指派TA</Button>
        <Button type="primary" size="small" class="btn" @click="$router.push({ name: 'order_pay', params: { id: order_id } })" v-if="worker_id == detail_worker_id && detail_status == 3"
          >已指派去付款</Button
        >
        <div class="tips" v-if="detail_status < 4 || worker_id != detail_worker_id">付款后可看见师傅电话</div>
        <div class="tips" v-if="detail_status > 3 && worker_id == detail_worker_id">
          <div>师傅电话</div>
          <div>{{ phone }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import baoIcon from '../../../../assets/images/bao2.png'
export default {
  name: 'master-item',
  props: {
    id: {
      type: Number,
      default: 0
    },
    thressMonthsCount: {
      type: [Number, String],
      default: 0
    },
    // 订单id
    order_id:{
      type: [Number, String],
      default: 0
    },
    oneMonthsCount: {
      type: [Number, String],
      default: 0
    },
    lastMonthNumber:{
      type: [Number, String],
      default: 0
    },
    worker_id: {
      type: Number,
      default: 0
    },
    tolls_time:{
      type: String,
      default: ''
    },
    detail_worker_id: {
      type: Number,
      default: 0
    },
    detail_status: {
      type: Number,
      default: 0
    },
    worker_order: {
      type: Number,
      default: 0
    },
    cooperateNumber:{
      type: Number,
      default: 0
    },
    score: {
      type: [Number, String],
      default: 0
    },
    phone: {
      type: String,
      default: ''
    },
    nickname: {
      type: String,
      default: ''
    },
    head_img: {
      type: String,
      default: ''
    },
    offer: {
      type: String,
      default: ''
    },
    message: {
      type: String,
      default: ''
    }
  },
  data: function () {
    return {
      baoIcon
    }
  },
  methods: {
    assign () {
      let vm = this
      this.$request('6123553996402', {
        offer_id: vm.id
      }).then((res) => {
        // this.$emit('assignSuccess')
        this.$router.push({
        	name: 'order_list'
        })
        this.$message.success('操作成功')
      })
    },
    gotoPay () {
      console.log('---')
      this.$emit('gotoPay')
    }
  }
}
</script>

<style scoped lang="less">
.master-item {
  width: 100%;
  padding: 10px 10px;
  border: 1px solid #f5f7f9;
  margin: 0 auto;
  margin-bottom: 20px;

  .master-card {
    width: 100%;
    margin: 0 auto;
    display: flex;

    .img {
      width: 120px;
      height: 120px;
    }

    .master-info {
      width: 30%;
      margin-left: 10px;
      min-height: 120px;
      //display: flex;
      //flex-direction: column;
      //justify-content: space-between;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .name {
        font-size: 14px;
        display: flex;
        align-items: center;
        .moneySave {
          margin-left: 14px;
        }
      }
      .desc {
        display: flex;
        align-items: center;
      }
      .desc,
      .num {
        font-size: 10px;
        color: #999999;
      }
      .textarea {
        background-color: rgba(#999999, 0.2);
        font-size: 10px;
        padding:8px;

        display: flex;
        &-name{
          width: 100px;
        }
      }

      .ivu-tag {
        display: inline-block;
        flex: none;
        width: 55px;
      }

      .num {
        color: #999;
      }
    }

    .contact {
      width: 25%;
      padding: 0 40px;

      .text1 {
        display: inline-block;
        border: 1px solid rgba(#999999, 0.3);
        padding: 8px 24px;
        font-size: 12px;
      }
    }

    .handle {
      flex: 1;
      text-align: right;

      .btn {
        margin-bottom: 5px;
      }

      .info-btn {
        cursor: pointer;
      }

      .tips {
        font-size: 12px;
        color: #bfbfbf;
      }
    }
  }
}
// TODO 2022/7/22 新增css
.mrs {
  display: inline-block;
  width: 120px;
  margin-right: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.pions {
  cursor: pointer;
}
.baoMoney {
  width: 16px;
  height: 16px;
  margin-top: 2px;
	background-color: #f8f8f8;
	border-radius: 8rpx;
}
</style>
